import FormLogo from './form-logo';
import FormTerms from './form-terms';
import { ReactNode } from 'react';

interface IFormBorder {
    children: ReactNode
}

/**
 * Common form border and alignment.
 */
const FormBorder = (props: IFormBorder) => {
    return (
        <main className="mx-4">
            <div
                className="mx-auto mt-8"
                style={{
                    width: '400px',
                    maxWidth: '100%'
                }}>

                <div className="border border-gray-200 rounded py-8 px-10">
                    <FormLogo />

                    { props.children }
                </div>

                <FormTerms />

            </div>
        </main>
    )
};

export default FormBorder;